import { useState } from 'react';
import { Users } from 'lucide-react';

const sizeConfig = {
  sm: {
    box: 'w-[18px] h-[18px]',
    text: 'text-[8px]',
  },
  md: {
    box: 'w-[22px] h-[22px]',
    text: 'text-[9px]',
  },
} as const;

export const PersonAvatar = ({
  initials,
  imageUrl,
  size = 'md',
}: {
  initials: string;
  imageUrl?: string;
  size?: 'sm' | 'md';
}) => {
  const [error, setError] = useState(false);
  const { box, text } = sizeConfig[size];

  if (imageUrl && !error) {
    return (
      <img
        src={imageUrl}
        alt={initials}
        onError={() => setError(true)}
        className={`${box} rounded-full object-cover flex-shrink-0`}
      />
    );
  }

  return (
    <span
      className={`flex items-center justify-center ${box} rounded-full bg-[#e5e7eb] ${text} font-semibold text-muted-foreground flex-shrink-0`}
    >
      {initials}
    </span>
  );
};

export const TeamIcon = ({ size = 'md' }: { size?: 'sm' | 'md' }) => {
  const { box } = sizeConfig[size];

  return (
    <span
      className={`flex items-center justify-center ${box} rounded-sm bg-[#e5e7eb] flex-shrink-0`}
    >
      <Users className="w-2.5 h-2.5 text-muted-foreground" />
    </span>
  );
};

export const SelectedCheckmark = () => (
  <span className="ms-auto text-[11px] text-primary">{'\u2713'}</span>
);
